<!--
    @Author : Luo
    @Time   : 2025/1/17 11:32
-->
<template>
  <div class="video text_left">
    <div class="video_nav">
      <div class="video_stage flex_center">
        <div v-for="i in stageData" :key="'s-' + i.id" :class="'video_stage_container text_center' + (i.id === stageCurrent ? ' video_stage_active' : '')" @click="stageCurrent = i.id">
          <span>{{ i.name }}</span>
        </div>
      </div>
    </div>
    <div class="video_main">
      <div class="video_main_con">
        <div v-for="i in videoData[stageCurrent]" :key="'s-v-' + i.id" class="video_main_info flex_center">
          <div class="video_main_info_con flex_center">
            <span>{{ i.name }}</span>
            <span>【{{ setTimeType(i.duration) }}】</span>
          </div>
          <div class="video_main_user_info">
            <div class="video_main_user_info_con flex_center" v-for="itemVideo in i.data" :key="'s-v-' + i.id + '-u-' + itemVideo.userId">
              <div><span>{{ userData[itemVideo.userId] }}</span></div>
              <div><span>进度：{{ (itemVideo.lastDuration / i.duration * 100).toFixed(2) }}%</span></div>
              <div><span>开始时间：{{ setDateType(itemVideo.createAt * 1000) }} {{ setDateSecond(itemVideo.createAt * 1000) }}</span></div>
              <div><span>最近观看时间：{{ setDateType(itemVideo.updatedAt * 1000) }} {{ setDateSecond(itemVideo.updatedAt * 1000) }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { _Ajax } from '@/api/_axios'
import { setTimeType, setDateType, setDateSecond } from '@/components/common/common_js'

export default {
  name: 'accountAnalysisPage',
  components: {},
  data () {
    return {
      baseUrl: '',

      userData: {},
      courseData: {},
      stageData: [],
      videoData: {},

      stageCurrent: '',

      setTimeType: setTimeType,
      setDateType: setDateType,
      setDateSecond: setDateSecond
    }
  },
  methods: {
    getData: function () {
      const that = this
      that.resetData()

      _Ajax({ baseUrl: that.baseUrl, method: 'get', url: '/ncs/list', clearCancelSource: true },
        (res) => {
          const _res = res.data

          if (_res.code === 200) {
            const _allVideoData = []

            that.stageData = _res.data.stage
            for (const item of _res.data.user) that.userData[item.id] = item.name
            for (const item of _res.data.course) that.courseData[item.id] = { stage: item.stageId, name: item.name }

            const _userData = Object.keys(that.userData)
            for (const item of _res.data.video) {
              const _courseData = that.courseData[item.courseId]
              const _videoData = _res.data.data.filter(i => i.id === item.id)
              const _stageId = _courseData ? _courseData.stage : '其它'
              const _appendData = [] // 追加未观看视频的用户

              for (const itemUser of _userData) {
                const _userVideoData = _videoData.filter(i => i.userId === itemUser)
                if (!_userVideoData.length) {
                  _appendData.push({
                    id: itemUser + '-' + item.id + _appendData.length,
                    userId: itemUser,
                    courseId: item.courseId,
                    stageId: _stageId,
                    lastDuration: 0
                  })
                }
              }

              _allVideoData.push({
                ...item,
                stageId: _stageId,
                data: _videoData.concat(_appendData)
              })
            }

            for (const item of that.stageData) that.videoData[item.id] = _allVideoData.filter(i => i.stageId === item.id)

            console.log('data-', that.videoData, 'user', that.userData, 'co', that.courseData)

            that.setDefaultStage()
          }
        },
        (rej) => { console.log('error--', rej) }
      )
    },
    setVideoData: function () { return this.videoData.filter(i => i.stageId === this.stageCurrent) },
    setDefaultStage: function () {
      this.stageCurrent = this.stageData[0].id
    },
    resetData: function () {
      this.userData = {}
      this.courseData = {}
      this.videoData = []
    }
  },
  mounted () {
    const that = this
    const envModule = process.env.ENV_MODULE

    that.baseUrl = envModule === 'development' ? 'https://ind.geetecho.com' : 'https://ind.geetecho.com'

    that.getData()
  }
}
</script>

<style scoped>
.video {padding: 20px}
.video_stage {justify-content: flex-start}
.video_stage_container {cursor: pointer;width: 120px;height: 48px;background: rgba(255, 255, 255, 1);border-radius: 24px}
.video_stage_container + .video_stage_container {margin-left: 24px}
.video_stage_container span {font-size: 16px;font-weight: 500;color: rgba(96, 96, 96, 1);line-height: 48px}
.video_stage_container:hover span {color: rgba(76, 139, 255, 1)}
.video_stage_container.video_stage_active {background: rgba(76, 139, 255, 1)}
.video_stage_container.video_stage_active span {color: rgba(255, 255, 255, 1)}

.video_main {padding: 20px 0 0}
.video_main_con {height: calc(100vh - 110px);overflow: auto}
.video_main_info {margin: 20px 10px;flex-flow: column;box-shadow: 1px 1px 10px rgba(144, 144, 144, 1);border-radius: 4px}
.video_main_info_con {cursor: pointer;padding: 0 10px;width: calc(100% - 20px);height: 48px;background: rgba(255, 255, 255, 1);border-radius: 14px}
.video_main_info_con span:first-of-type {font-size: 16px;font-weight: bold;color: rgba(96, 96, 96, 1)}
.video_main_info_con span:last-of-type {margin-left: 10px;font-size: 14px;font-weight: 400;color: rgba(96, 96, 96, 1)}
.video_main_user_info {padding: 20px 0}
.video_main_user_info_con {justify-content: flex-start;height: 30px;padding: 0 0 0 10px}
.video_main_user_info_con:nth-of-type(2n) {background-color: rgb(196, 196, 196, .3)}
.video_main_user_info_con div:nth-of-type(1) {width: 100px}
.video_main_user_info_con div:nth-of-type(2) {width: 150px}
.video_main_user_info_con div:nth-of-type(3) {width: 300px}
.video_main_user_info_con div:nth-of-type(4) {width: 300px}
</style>



// WEBPACK FOOTER //
// src/components/page-video2/index.vue